/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Træk for at ændre panelstørrelsen',
  command_intelligence_close_aria: 'Luk assistent',
  command_intelligence_send_aria: 'Send besked',
  command_intelligence_stop_aria: 'Stop svar',
  command_intelligence_composer_input_aria: 'Besked til Command Intelligence',
  command_intelligence_drawer_more_options: 'Flere muligheder',
  command_intelligence_dock_position: 'Dockingsposition',
  command_intelligence_dock_left: 'Venstre',
  command_intelligence_dock_right: 'Højre',
  command_intelligence_dock_top: 'Top',
  command_intelligence_dock_bottom: 'Bund',
  command_intelligence_panel_layout: 'Panellayout',
  command_intelligence_panel_layout_overlap: 'Overlap indhold',
  command_intelligence_panel_layout_push: 'Skub indhold',
  command_intelligence_panel_auto_hide_overlap: 'Skjul automatisk ved klik uden for',
  command_intelligence_session_reset: 'Nulstil samtale',
  command_intelligence_try_one_of_these: 'Prøv en af disse',
  command_intelligence_attach_hint: 'Vedhæft kontekstelementer for at begynde at stille spørgsmål.',
  command_intelligence_attach_modal_title: 'Vedhæft kontekst',
  command_intelligence_attach_modal_subtitle:
    'Vælg fra elementer i denne visning. Allerede vedhæftede elementer er nedtonet.',
  command_intelligence_attach_modal_search_placeholder: 'Søg…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# element tilgængeligt} other {# elementer tilgængelige}} · {selected} valgt',
  command_intelligence_attach_modal_empty: 'Intet tilgængeligt at vedhæfte',
  command_intelligence_attach_modal_no_results: 'Ingen elementer matcher din søgning',
  command_intelligence_context_bar_attached_section: 'Vedhæftet ({count})',
  command_intelligence_context_bar_clear_attached: 'Ryd',
  command_intelligence_context_bar_add: 'Vedhæft kontekst',
  command_intelligence_placeholder_ready: 'Stil et spørgsmål…',
  command_intelligence_placeholder_attach: 'Vedhæft kontekst for at stille et spørgsmål…',
  command_intelligence_composer_submit_hint: 'Enter for at sende · Shift+Enter for ny linje',
  command_intelligence_composer_stop_hint: 'Stop · udkast til næste besked mens du venter',
  command_intelligence_response_stopped: 'Svar stoppet',
  command_intelligence_generation_in_progress: 'Arbejder på dit spørgsmål',
  command_intelligence_generation_trace_title: 'Udførte trin',
  command_intelligence_generation_trace_toggle: 'Vis trin',
  command_intelligence_generation_trace_summary: '{completed} af {total} trin fuldført',
  command_intelligence_generation_trace_summary_generic: 'Genereringstrin',
  command_intelligence_generation_tool_count: '{count, plural, one {# værktøj} other {# værktøjer}}',
  command_intelligence_generation_turn_label: 'Tur {turn} af {total}',
  command_intelligence_generation_turn_completed: 'Tur {turn} af {total} fuldført',
  command_intelligence_generation_turn_completed_elapsed: 'Tur {turn} af {total} fuldført ({seconds}s forløbet)',
  command_intelligence_generation_turn_completed_with_tools: 'Tur {turn} af {total} fuldført – brugte {tools}',
  command_intelligence_generation_tools_used: 'Brugte {tools}',
  command_intelligence_reasoning_thinking: 'Tænker…',
  command_intelligence_reasoning_thought_for_seconds: 'Tænkte i {seconds} sekunder',
  command_intelligence_reasoning_waiting: 'Arbejder på dit spørgsmål…',
  command_intelligence_attach_modal_done: 'Færdig',
  command_intelligence_attach_modal_attached_badge: 'vedhæftet',
  command_intelligence_attach_modal_attach: 'Vedhæft',
  command_intelligence_attach_modal_attach_count: 'Vedhæft ({count})',
  command_intelligence_attach_modal_close_aria: 'Luk vælger',
  command_intelligence_session_limit_context: 'Kontekstgrænse nået. Nulstil samtalen for at fortsætte.',
  command_intelligence_session_limit_prompt: 'Beskedgrænse nået. Nulstil samtalen for at fortsætte.',
  command_intelligence_suggested_followups: 'Foreslåede opfølgninger',
  command_intelligence_credit_warning_line: '{pct}% af månedlige AI-kreditter for {scope} brugt',
  command_intelligence_tooltip_prompts: '{count} af {max} beskeder ({pct}%)',
  command_intelligence_tooltip_context: '{used} af {max} konteksttokens ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Kontekstforbrug vises efter det første svar',
  command_intelligence_credits_loading: 'Indlæser kreditter…',
  command_intelligence_credits_unavailable: 'Kreditter utilgængelige',
  command_intelligence_credits_tooltip: 'Månedlige AI-kreditter for {monthKey}',
  command_intelligence_credits_tooltip_short: 'Månedlige AI-kreditter',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Enhed',
  command_intelligence_credits_used_of_cap: '{used} af {cap} kreditter',
  command_intelligence_credits_used_no_cap: '{used} kreditter brugt',
  command_intelligence_credits_monthly_title: 'Månedlige AI-kreditter',
  command_intelligence_compare_aria: 'Sammenlign agenter',
  command_intelligence_compare_tooltip: 'Kør det samme spørgsmål mod flere agentprofiler',
  command_intelligence_compare_cancelled: 'Sammenligning annulleret',
  command_intelligence_compare_branch_failed: 'Sammenligningsgren mislykkedes',
  command_intelligence_compare_title: 'Agentsammenligning',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} ind / {outTok} ud · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Godt svar',
  command_intelligence_feedback_bad_response: 'Dårligt svar',
  command_intelligence_feedback_dialog_title: 'Giv feedback',
  command_intelligence_feedback_dialog_body:
    'Hjælp os med at forbedre os ved at give feedback på dette svar. Din feedback sendes til vores driftsteam.',
  command_intelligence_feedback_response_label: 'Svar',
  command_intelligence_feedback_input_label: 'Din feedback (valgfrit)',
  command_intelligence_feedback_input_placeholder: 'Hvad var forkert eller ubrugeligt ved dette svar?',
  command_intelligence_feedback_submit: 'Send feedback',
  command_intelligence_feedback_submit_error: 'Kunne ikke sende feedback. Prøv igen.',
  command_intelligence_feedback_question_understanding: 'Forstod agenten, hvad du ønskede?',
  command_intelligence_feedback_question_readability: 'Var svaret let at læse og bruge?',
  command_intelligence_feedback_section_understanding: 'Forståelse',
  command_intelligence_feedback_section_readability: 'Læsbarhed',
  command_intelligence_feedback_choice_none: 'Ingen',
  command_intelligence_feedback_choice_misunderstood_task: 'Misforstod opgave',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignorerede begrænsning',
  command_intelligence_feedback_choice_wrong_scope: 'Forkert omfang',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuelt svær at læse',
  command_intelligence_feedback_choice_wrote_too_much: 'Skrev for meget',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Forklaring ikke troværdig',
  command_intelligence_copy_aria: 'Kopiér til udklipsholder',
  command_intelligence_error_missing_invoke_permission:
    'Du har ikke tilladelse til at bruge Command Intelligence for denne agent. Bed din administrator om at give de nødvendige Intelligence-tilladelser (f.eks. analyst).',
  command_intelligence_access_denied_title: 'Adgang påkrævet',
  command_intelligence_error_session_expired: 'Din session er udløbet. Opdater siden og log ind igen.',
};
